import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: "I thought I was too late to the AI trend. This book didn't just teach me prompts; it gave me a system. I've automated 30% of my weekly reporting.",
  name: 'Sarah K.',
  role: 'Senior Project Manager'
}, {
  quote: "The 'AI-Raise' script alone was worth 100x the price. I used the frameworks to pitch a new workflow to my VP and secured a $15k bump.",
  name: 'Marcus T.',
  role: 'Marketing Director'
}, {
  quote: 'No fluff. No generic ChatGPT lists. Just pure, actionable strategy for professionals who want to stay relevant. Mandatory reading.',
  name: 'Elena R.',
  role: 'Operations Lead'
}];
export const Testimonials = () => {
  return <section className="py-20 px-4 bg-brand-light border-y border-brand-dark/5" data-id="element-131">
      <div className="max-w-6xl mx-auto" data-id="element-132">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-133">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white p-8 rounded-sm shadow-sm border border-brand-dark/5" data-id="element-134">
              <div className="flex gap-1 mb-4 text-brand-gold" data-id="element-135">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-current" data-id="element-136" />)}
              </div>
              <p className="text-brand-dark/80 italic mb-6 leading-relaxed" data-id="element-137">
                "{t.quote}"
              </p>
              <div data-id="element-138">
                <div className="font-bold text-brand-dark" data-id="element-139">{t.name}</div>
                <div className="text-sm text-brand-dark/50" data-id="element-140">{t.role}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};